import React, {useEffect, useState} from "react";
import { CircularProgressCustom } from "../common-components/CircularProgressCustom";
import { Container, Row, Col } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import { apiUrl } from "../../../services/constants";
import { useNavigate } from "react-router-dom";
import "./home.css";

const NewCaseStudies = () => {
    const navigate = useNavigate();


    const [data, setData] = useState(null);
    const [error, setError] = useState(false);

    const fetchGraphQL = async (endpoint) => {
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        });
        if (!response.ok) throw new Error(`Error: ${response.status}`);
        return response.json();
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [newCaseStudies] = await Promise.all([
                    fetchGraphQL('/api/graphql/get-new-case-studies'),
                ]);
                setData({newCaseStudies});
            } catch (error) {
                setError(true);
            }
        };

        void fetchData();
    }, []);



    if (!data) return <CircularProgressCustom />;

    if (error)
        return (
            <>
                <h1>Sorry... We have some error</h1>
            </>
        );

    return (
        <div className="case-studies">
            <Container className="studies-container">
                <Row style={{ alignItems: "center", justifyContent: "center" }}>
                    <h2>Read Our Case Studies</h2>
                </Row>
                <Row className="studies">
                    {data.newCaseStudies.data.newCaseStudies?.data?.map((item, key) => (
                        <Col md={4} className="studies-items" key={key}>
                            <img
                                src={
                                    apiUrl +
                                    item?.attributes?.Image_New_Case_Study?.data
                                        ?.attributes?.url
                                }
                                alt={
                                    item?.attributes?.Image_New_Case_Study?.data
                                        ?.attributes?.name
                                }
                                width="100%"
                                height="300px"
                            />
                            <div className="studies-contents">
                                <h4>
                                    {item?.attributes?.Title_New_case_study}
                                </h4>
                                <p>
                                    {
                                        item?.attributes?.category?.data
                                            ?.attributes?.name
                                    }
                                </p>
                                <p>
                                    {
                                        item?.attributes?.collection?.data
                                            ?.attributes?.name
                                    }
                                </p>
                                <p
                                    className="read-now"
                                    onClick={() =>
                                        navigate(
                                            `/${item?.attributes.Invisible_URL_Position_field}`
                                        )
                                    }
                                >
                                    READ NOW{" "}
                                    <BsArrowRight
                                        style={{ marginLeft: "10px" }}
                                    />
                                </p>
                            </div>
                        </Col>
                    ))}
                </Row>
                <Row
                    style={{ alignItems: "center", justifyContent: "center" }}
                    className="mt-5"
                >
                    <button
                        className="learn-about-us-btn"
                        onClick={() => navigate("/case-study")}
                    >
                        VIEW ALL CASE STUDIES{" "}
                        <BsArrowRight style={{ marginLeft: "20px" }} />
                    </button>
                </Row>
            </Container>
        </div>
    );
};

export default NewCaseStudies;
